import React, { useState, useRef, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SimpleReactValidator from "simple-react-validator";

const reg = /^([a-zA-Z0-9_-]){5,5}$/;
function Register() {
    const [, forceUpdate] = useState();
    const [room, setRoom] = useState("");
    const [roomError, setRoomError] = useState(false);
    const validator = useRef(new SimpleReactValidator({
        messages: {
            email: 'Please enter a valid username.'
        },
        autoForceUpdate: { forceUpdate }
    }));

    useEffect(() => {
        if (reg.test(room)) {
            setRoomError(false);
        }
    }, [room]);

    const _onFormSubmit = () => {
        if (!validator.current.allValid()) {
            validator.current.showMessages();
            forceUpdate(1);
            return false;
        }
        if (!reg.test(room)) {
            return setRoomError(true);
        }

        window.location.href = room;
    }
    return (
        <section className="login_bg sign_up">
            <div className="container">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-4 col-sm-3"></div>
                        <div className="col-md-4 col-sm-6">
                            <div className="login_block">
                                <div className="login_about">
                                </div>
                                <div className="row">
                                    <div className="col-lg-12 col-sm-12">
                                        <form>
                                            <div className="form_login">
                                                <div className="form-group">
                                                    <div className="col-md-12 text-center">
                                                        <img src="../../../images/logo.png" style={{ width: '120px' }} className="center-block" alt="..." />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-md-12 text-center">
                                                        <h3>Register Device</h3>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-sm-12">
                                                        <div className="input-group input-group-lg">
                                                            <div className="input-group-addon">
                                                                <i className="fa fa-user"></i>
                                                            </div>
                                                            <input type="text"
                                                                autoFocus={true}
                                                                className='form-control'
                                                                id='enter_room_field'
                                                                onChange={e => setRoom(e.target.value)}
                                                                value={room} />
                                                            <i className="fa fa-question-circle help_icon" data-toggle="tooltip" title="Introduce the 5 character registration key generated by the device" ></i>
                                                            {/* Introduce the registration key generated by the VR device */}
                                                        </div>
                                                        {validator.current.message("Room", room, `required`)}
                                                        {room && roomError ? <div className='srv-validation-message'>Please enter a valid registration key</div> : null}
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="col-sm-12">
                                                                <div className="col-xs-12 text-right">
                                                                    <button type="button" onClick={_onFormSubmit} id='enter_room_button' className="btn btn-primary  btn-sm"  >Continue</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Register